@use "../../../../../../src/styles/Colors.scss" as Colors;

.privacyPolicyLink {
	color: Colors.$col-blue
}

.privacyPolicyLink:hover {
	color: Colors.$col-blueHover
}